/**
 * Greek translations for footer.
 *
 * @module languages/el/footer
 */
const footer = {
  about_us_link_text: 'Σχετικά με εμάς',
  privacy_policy_link_text: 'Πολιτική Απορρήτου',
  terms_of_service_link_text: 'Όροι χρήσης',
};

export default footer;
